<div class="d-flex flex-column align-items-center mt-5">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <h3>Buy Units</h3>
    <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="submitUnit()">
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Units</label>
        <input class="form-control" [(ngModel)]="buyUnits.units" name="Units" type="number" min="0"
          (input)="getPrice()" />
      </div>
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Price</label>
        <input class="form-control" type="number" min="0" disabled [(ngModel)]="buyUnits.price" name="price">
        <sub>Webtest unit price: {{buyUnits.pricePerUnit}}</sub>
      </div>

      <button class="btn btn-primary btn-lg col-md-10" type="submit"> Buy
      </button>
    </form>
  </div>
</div>